import {Link} from "react-router-dom";
import React from "react";
import {Tooltip} from "@mui/material";

export const FitrLogoLink = () => (
  <Tooltip title={"Supported by FITR"}>
    <Link to={"https://fitr.mk/"} style={{mixBlendMode: "multiply", fontSize: 12,textDecoration: "none", color: "#252525"}}><img src={"/fitr.png"} alt={"logo"} width={100}/></Link>
  </Tooltip>
)